/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* Source: https://github.com/backstage/backstage/blob/master/plugins/catalog/src/components/EntityContextMenu/UnregisterEntity.tsx */

import { Icon } from '@iconify/react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

export type UnregisterEntityOptions = {
  disableUnregister: boolean | VisibleType;
};

type UnregisterEntityProps = {
  isUnregisterAllowed: boolean;
  onClose: () => void;
  onUnregisterEntity: () => void;
  unregisterEntityOptions?: UnregisterEntityOptions;
};

type VisibleType = 'disable' | 'hidden' | 'visible';

export const UnregisterEntity = (props: UnregisterEntityProps) => {
  const {
    isUnregisterAllowed,
    onClose,
    onUnregisterEntity,
    unregisterEntityOptions,
  } = props;

  const isBoolean =
    typeof unregisterEntityOptions?.disableUnregister === 'boolean';

  const isDisabled =
    (!isUnregisterAllowed
      || (isBoolean
        ? !!unregisterEntityOptions?.disableUnregister
        : unregisterEntityOptions?.disableUnregister === 'disable'))
      ?? false;

  let unregisterButton = null;

  if (unregisterEntityOptions?.disableUnregister !== 'hidden') {
    unregisterButton = (
      <MenuItem
        disabled={isDisabled}
        onClick={() => {
          onClose();
          onUnregisterEntity();
        }}
      >
        <ListItemIcon>
          <Icon fontSize={20} icon="material-symbols:cancel" />
        </ListItemIcon>
        <ListItemText primary="Unregister entity" />
      </MenuItem>
    );
  }

  return unregisterButton;
};
